import React from 'react'

export default function BtnLoader({ label, color='#ffffff' }) {
    return (
        <span>{label}<div className='btnloader' style={{background : `radial-gradient(circle closest-side,${color} 90%,#0000) 0/calc(100%/3) 100% space`}} /></span>
    )
}
